import React, { Component } from "react";
import { withDomains, RESTExecutor } from "../../lib/domain";
import { Link } from "react-router-dom";
import {
  Typography,
  Table,
  Row,
  Button,
  Divider,
  Input,
  Spin,
  Tag,
  Badge,
  message,
  Alert,
  Space,
  Popconfirm,
} from "antd";
import {
  showErrorInNotification,
  NetworkDelaySearch,
  overrideHeaderTitle,
  overrideHeaderBack,
  showSuccessInNotification,
  formatMoney,
} from "../../lib/util";
import ErrorWrapper from "../../lib/error_wrapper";
import { BasicHeader } from "../../components/basic_header";
import {
  StarOutlined,
  StarBorder,
  StorageOutlined,
  InsertDriveFileOutlined,
  LayersOutlined,
  WifiTetheringOutlined,
  CloudUploadOutlined,
  CloudDownloadOutlined,
} from "@material-ui/icons";
import { TransparentButton } from "../../components/basic_items";
import { recon_quick_menu } from "../../util/ui_util";
import FilterFixedInput from "../../components/filter_fixed_input";
import NetworkSelect from "../../lib/ui/network_select";
import { PopUpForm } from "../../lib/ui/popupform";
import DayDifferennceTag from "../../components/day_difference_tag";
import ReversalConfig from "./reversal_config";
const queryString = require("query-string");

const { Title, Paragraph, Text } = Typography;

class DatatypeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter_query: {},
      selected_id: null,
      reversal_selected_id: null,
      selected_data: {},
    };

    this.list_datatypes = RESTExecutor.list()
      .config({
        label: "datatypes",
        params: {
          per_page: 100,
        },
      })
      .connect(props.domains.allData);

    this.mark_favourite = RESTExecutor.post()
      .config({
        label: "datatype_mark_fav",
      })
      .callbacks(
        (success) => {
          message.success("Marked Favourite");
          this.list_datatypes.execute();
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.allData);

    this.unmark_favourite = RESTExecutor.post()
      .config({
        label: "datatype_unmark_fav",
      })
      .callbacks(
        (success) => {
          message.success("Removed Favourite");
          this.list_datatypes.execute();
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.allData);

    this.upload_data = RESTExecutor.post()
      .config({
        label: "upload_datatype_file",
      })
      .callbacks((success) => {
        this.setState({
          selected_id: null,
          selected_data: {},
        });
        message.success("File Uploaded");
      })
      .connect(props.domains.activity);

    this.upload_reversal = RESTExecutor.post()
      .config({
        label: "upload_datatype_reversal",
      })
      .callbacks((success) => {
        this.setState({
          reversal_selected_id: null,
          selected_data: {},
        });
        message.success("Reversal Uploaded");
      })
      .connect(props.domains.activity);

    this.download_template = RESTExecutor.detail()
      .config({
        label: "download_template",
      })
      .callbacks(
        (success) => {
          console.log("got success", success.result);
          window.open(success.result.url, "_blank");
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.activity);

    this.start_removing_duplicates = RESTExecutor.post()
      .config({
        label: "remove_duplicate",
      })
      .callbacks(
        (s) => {
          showSuccessInNotification(s, "Duplicate removal started");
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.activity);

    this.run_datatype = RESTExecutor.post()
      .config({
        label: "run_datatype",
      })
      .callbacks(
        (success) => {
          showSuccessInNotification(success, "Operation Successful");
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.activity);

    this.delay_search = new NetworkDelaySearch();
  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj);
    }
    console.log(newData);
    this.setState(
      {
        [stateKey]: newData,
      },
      () => {
        typeof callback === "function" && callback();
      }
    );
  };

  render() {
    let list_datatype_resp = this.list_datatypes.response();
    let list_datatype_data = list_datatype_resp.result || {};
    let rowsData = list_datatype_data.rows || [];
    let rowsMeta = list_datatype_resp.meta || {};

    let download_template_resp = this.download_template.response();
    let run_datatype_resp = this.run_datatype.response();
    let upload_data_resp = this.upload_data.response();
    let upload_reversal_resp = this.upload_reversal.response();

    let start_removing_duplicates_resp =
      this.start_removing_duplicates.response();

    const { filter_query } = this.state;

    return (
      <ErrorWrapper
        error={list_datatype_resp}
        onReload={() => {
          this.list_datatypes.execute();
        }}
      >
        <BasicHeader
          no_back
          title="Datatypes"
          menu_items={recon_quick_menu}
          right={[
            <Popconfirm
              title="Are you sure you want to start removing duplicates?"
              onConfirm={() => {
                this.start_removing_duplicates.execute();
              }}
            >
              <TransparentButton
                loading={start_removing_duplicates_resp.fetching}
                disabled={start_removing_duplicates_resp.fetching}
                label="Start Duplicate Remove"
                className="cta-primary"
                hint="Start removing duplicates"
                onClick={() => {}}
              />
            </Popconfirm>,
          ]}
        />
        <PopUpForm
          title={`Reversal File Upload For ${this.state.selected_data.name}`}
          stringyfy={false}
          show_title_only
          forCreate={true}
          initialData={this.state.form_data}
          fields={[
            { index: "file", name: "File", type: "file", compress: true },
          ]}
          open={this.state.reversal_selected_id != null}
          networkState={upload_reversal_resp}
          onClose={() =>
            this.setState({ reversal_selected_id: null, selected_data: {} })
          }
          onSubmit={(data) => {
            console.log("DATA", data);
            if (!data.file) {
              message.warn("Cannot upload empty data...");
              return;
            } else {
              let _formdata = new FormData();
              Object.keys(data).map((key) => {
                _formdata.append(key, data[key]);
              });
              // message.warn("END POINT NOT MADE")
              this.upload_reversal
                .forId(this.state.reversal_selected_id)
                .execute(_formdata);
            }
            // this.handlePostPatch(data);
          }}
        />

        <PopUpForm
          title={`File Upload For ${this.state.selected_data.name}`}
          stringyfy={false}
          show_title_only
          forCreate={true}
          initialData={this.state.form_data}
          top={
            <div>
              <Alert
                banner
                closable
                message="Please Note Following things before uploading"
                description={
                  <div>
                    <ul>
                      <li>
                        Please use <strong>Excel</strong> format only
                      </li>
                      <li>
                        Download{" "}
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            if (!download_template_resp.fetching) {
                              this.download_template
                                .forId(this.state.selected_id)
                                .execute();
                            }
                          }}
                        >
                          template
                        </a>{" "}
                        for reference
                      </li>
                    </ul>
                  </div>
                }
              />
            </div>
          }
          bottom={
            <div
              style={{
                paddingTop: 16,
                paddingBottom: 8,
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <TransparentButton
                // className='cta-normal'
                label="Download Template"
                disabled={download_template_resp.fetching}
                onClick={() => {
                  // this.setState({
                  //   upload_form_visibility: true
                  // })
                  this.download_template
                    .forId(this.state.selected_id)
                    .execute();
                }}
                icon={<CloudDownloadOutlined className="btn-icon" />}
              />
            </div>
          }
          fields={[
            { index: "file", name: "File", type: "file", compress: true },
          ]}
          open={this.state.selected_id != null}
          networkState={upload_data_resp}
          onClose={() =>
            this.setState({ selected_id: null, selected_data: {} })
          }
          onSubmit={(data) => {
            console.log("DATA", data);
            if (!data.file) {
              message.warn("Cannot upload empty data...");
              return;
            } else {
              let _formdata = new FormData();
              Object.keys(data).map((key) => {
                _formdata.append(key, data[key]);
              });
              // message.warn("END POINT NOT MADE")
              this.upload_data.forId(this.state.selected_id).execute(_formdata);
            }
            // this.handlePostPatch(data);
          }}
        />
        <div className="filter-card">
          <div
            className="filter-card-top"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              flexWrap: "nowrap",
            }}
          >
            <Input.Search
              placeholder="Search For"
              style={{}}
              autoFocus
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: "filter_query",
                  valueKey: "query",
                  value: e.target.value,
                  callback: () => {
                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        // pathname:"users",
                        search: queryString.stringify({
                          ...this.state.filter_query,
                          per_page: 100,
                          page: 1,
                        }),
                      });
                    });
                  },
                });
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              // justifyContent: 'space-between',
              flexWrap: "wrap",
              paddingTop: 4,
              paddingBottom: 4,
            }}
          >
            <FilterFixedInput label="Group">
              <NetworkSelect
                value={filter_query.group_id}
                style={{ marginRight: 8 }}
                item={{
                  name: "Group",
                  className:
                    filter_query.group_id != null
                      ? "filter-option-selected"
                      : "",
                }}
                url={`/my-groups`}
                onChange={(received_value) => {
                  this.stateUpdater({
                    stateKey: "filter_query",
                    valueKey: "group_id",
                    value: received_value,
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({
                          ...this.state.filter_query,
                          page: 1,
                        }),
                      });
                    },
                  });
                  // this._change(item.index, received_value, d_key)
                }}
              />
            </FilterFixedInput>
          </div>
        </div>

        <div
          className="default-card"
          style={
            {
              // padding: 8
            }
          }
        >
          <Table
            // rowClassName='hand-cursor'
            className="main-table noHover"
            loading={list_datatype_resp.fetching || run_datatype_resp.fetching}
            size="small"
            scroll={{ x: true }}
            pagination={{
              // simple: true,
              position: "bottom",
              onChange: (current, size) => {
                this.props.history.push({
                  search: queryString.stringify({
                    ...this.state.filter_query,
                    per_page: size,
                    page: current,
                  }),
                });
              },
              defaultCurrent: 1,
              current:
                rowsMeta.pagination &&
                parseInt(rowsMeta.pagination.split("/")[0]),
              // defaultPageSize: 20,
              pageSize: rowsMeta && rowsMeta.requested_count,

              total: rowsMeta && rowsMeta.total_count,
              showTotal: (total, range) =>
                `${formatMoney(range[0], 0)}-${formatMoney(
                  range[1],
                  0
                )} of ${formatMoney(total, 0)} items`,
            }}
            rowKey={(record) => record.id}
            columns={[
              // {
              //     title: <StarBorder titleAccess='Favourite' className='star-inactive hand-cursor'/>, dataIndex: 'favourite', key: 'favourite', render: (favourite, record) => {
              //         return <StarBorder
              //             className={favourite ? 'star-active hand-cursor' : 'star-inactive hand-cursor'}
              //             titleAccess="Toggle Favourite"

              //             onClick={() => {
              //                 if (favourite) {
              //                     this.unmark_favourite.forId(record.id).execute();
              //                 } else {
              //                     this.mark_favourite.forId(record.id).execute()
              //                 }
              //             }}
              //         />
              //     }
              // },
              {
                title: "NAME",
                dataIndex: "name",
                key: "name",
                className: "bold-cell",
                render: (value, record) => {
                  return (
                    <span>
                      {record.group_name} {">"} {value}
                    </span>
                  );
                },
              },
              // {title:"Group",dataIndex:'group_name',key:'group_name'},
              {
                title: "",
                dataIndex: "id",
                key: "id",
                render: (id) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Link
                        to={`/activity/data-type/${id}/files`}
                        style={{ color: "inherit" }}
                      >
                        <TransparentButton
                          className="cta-normal"
                          label="Files"
                          icon={
                            <InsertDriveFileOutlined className="btn-icon" />
                          }
                        />
                      </Link>
                      <Divider type="vertical" />
                      <Link
                        to={`/activity/data-type/${id}/sources`}
                        style={{ color: "inherit" }}
                      >
                        <TransparentButton
                          className="cta-normal"
                          label="Sources"
                          icon={<WifiTetheringOutlined className="btn-icon" />}
                        />
                      </Link>
                      <Divider type="vertical" />

                      <Link
                        to={`/activity/data-type/${id}/packets`}
                        style={{ color: "inherit" }}
                      >
                        <TransparentButton
                          className="cta-normal"
                          label="Packets"
                          icon={<LayersOutlined className="btn-icon" />}
                        />
                      </Link>
                      <Divider type="vertical" />
                      <Link
                        to={{
                          pathname: `/activity/data-type/${id}/transactions`,
                        }}
                        style={{ color: "inherit" }}
                      >
                        <TransparentButton
                          className="cta-normal"
                          label="Transactions"
                          icon={<StorageOutlined className="btn-icon" />}
                        />
                      </Link>
                    </div>
                  );
                },
              },
              {
                title: "LAST FETCHED",
                dataIndex: "last_fetched",
                key: "last_fetched",
                width: 120,
                className: "center-align",
                render: (val) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <DayDifferennceTag date={val} />
                    </div>
                  );
                },
              },
              {
                title: "ACTION",
                dataIndex: "id",
                key: "action",
                className: "center-align",
                width: 50,
                render: (id, data) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Space size={8}>
                        <Button
                          onClick={() => {
                            this.setState({
                              selected_data: data,
                              selected_id: id,
                            });
                          }}
                          type="link"
                        >
                          Upload
                        </Button>
                        <Button
                          onClick={() => {
                            this.setState({
                              selected_data: data,
                              reversal_selected_id: id,
                            });
                          }}
                          type="link"
                        >
                          Reversal Upload
                        </Button>
                        <ReversalConfig data_id={id} />
                        <Popconfirm
                          placement="bottomRight"
                          onConfirm={() => {
                            this.run_datatype.forId(id).execute();
                            // this.loading_message = message.loading(`Running Fetcher ${data.fetcher} for Repository ${data.name}`, 0);
                            // this.run_fetcher.forId(id).execute();
                          }}
                          title={
                            <span>
                              Are you sure you want to run all{" "}
                              <b>Reconcilers</b> for this <b>Datatype</b>?
                            </span>
                          }
                        >
                          <Button
                            onClick={() => {
                              // this.setState({ selected_repo: data })
                            }}
                            type="link"
                          >
                            Run
                          </Button>
                        </Popconfirm>
                      </Space>
                    </div>
                  );
                },
              },
            ]}
            dataSource={rowsData}
          />
        </div>
      </ErrorWrapper>
    );
  }

  componentDidMount() {
    // this.list_datatypes.execute();
    overrideHeaderTitle("Datatype List");
    overrideHeaderBack(null);
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState(
      {
        filter_query: {
          per_page: 100,
          page: 1,
          ...new_filter_query,
        },
      },
      () => {
        this.list_datatypes
          .config({
            params: {
              ...this.state.filter_query,
            },
          })
          .execute();
      }
    );
  }
  componentWillUnmount() {}
  componentWillReceiveProps(nextProps) {
    let new_filter_query = {};
    if (this.props.location.search !== nextProps.location.search) {
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query = parsed;
      this.setState(
        {
          filter_query: {
            per_page: 100,
            page: 1,
            ...new_filter_query,
          },
        },
        () => {
          this.list_datatypes
            .config({
              params: {
                ...this.state.filter_query,
              },
            })
            .execute();
        }
      );
    } else {
      //   this.list_logs.execute()
    }
  }
}

export default withDomains(DatatypeList, "allData", "activity");

class ServiceListForDatatypeOnly extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: false,
      service_list: [],
    };
    this.list_services = RESTExecutor.list()
      .config({
        label: "datatype_services",
      })
      .callbacks(
        (success) => {
          this.setState({ loading: false, service_list: success.result.rows });
        },
        (error) => {
          this.setState({
            loading: false,
            error: true,
          });
        }
      )
      .forId(this.props.datatype)
      .connect(props.domains.allData);

    this.list_services.execute();
    console.log("constructed");
  }

  render() {
    const { loading, error, service_list } = this.state;
    if (loading) {
      return <Spin className="white-spin" />;
    }
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Title level={4} type="secondary">
          Services
        </Title>
        <Row type="flex">
          {service_list.map((item) => {
            return (
              <Link
                className="hand-cursor"
                to={{
                  pathname: `/activity/data-type/${this.props.datatype}/transactions`,
                  search: `service=${item.id}`,
                }}
              >
                <Tag className="hand-cursor" style={{ margin: 4 }}>
                  <Badge
                    className="faded-text-badge"
                    color={item.color_code}
                    text={item.name || "Unknown Service"}
                  />
                </Tag>
              </Link>
            );
          })}
        </Row>
        <div>
          {this.state.error && !this.state.loading && (
            <Button
              type="link"
              onClick={() => {
                this.setState({ loading: true, error: false });
                this.list_services.execute();
              }}
              style={{
                color: "black",
              }}
            >
              Retry
            </Button>
          )}
        </div>
        <div>
          {!this.state.error &&
            !this.state.loading &&
            service_list.length === 0 && (
              <Button
                type="link"
                style={{
                  color: "black",
                }}
              >
                No any Services
              </Button>
            )}
        </div>
      </div>
    );
  }
}
const ServiceListForDatatype = withDomains(
  ServiceListForDatatypeOnly,
  "allData"
);
